import React from 'react'
import styles from './WarRoomLoadingScreen.module.css'

export interface WarRoomLoadingScreenProps {
  message?: string
  className?: string
}

export function WarRoomLoadingScreen({
  message = 'Loading War Room…',
  className,
}: WarRoomLoadingScreenProps) {
  return (
    <div
      className={`${styles.screen} ${className || ''}`}
      role="status"
      aria-label={message}
      data-testid="war-room-loading-screen"
    >
      <div className={styles.spinner} aria-hidden="true" />
      <span className={styles.label}>{message}</span>
    </div>
  )
}
